import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getStorage } from '../utils/functions/localstorage';
import { checkAccessRights } from '../utils/functions/accessRight';
import { ROLES } from '../utils/constants';

const USER = process.env.REACT_APP_API_URL;
const ADMIN = process.env.REACT_APP_API_URL_admin;

const baseQuery = fetchBaseQuery({
  baseUrl: `${
    checkAccessRights(ROLES.ADMIN_ROLE) ||
    checkAccessRights(ROLES.SUPER_ADMIN_ROLE) ||
    checkAccessRights(ROLES.SALE_ROLE) 
      ? ADMIN
      : USER
  }`,
  prepareHeaders: (headers) => {
    const token = getStorage('token');
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

export const merchantApi = createApi({
  reducerPath: 'merchantApi',
  baseQuery,
  endpoints: (builder) => ({
    getMerchantUserRole: builder.query({
      query: () => '/customer/group-merchant',
    }),
    getMerchantAdminRole: builder.query({
      query: (q) =>
        `/customer/group-merchant?federalTaxId=${q.tax_id}&sorgcode=${q.sorgcode}`,
    }),
    getMerchantSuperAdmin: builder.query({
      query: (taxId) => `/customer/group-merchant?federalTaxId=${taxId}`,
    }),
    getMerchantAll: builder.query({
      query: () => '/customer/group-all-merchant',
    }),
  }),
});

export const {
  useGetMerchantUserRoleQuery,
  useGetMerchantAdminRoleQuery,
  useLazyGetMerchantAdminRoleQuery,
  useGetMerchantSuperAdminQuery,
  useGetMerchantAllQuery,
  useLazyGetMerchantAllQuery
} = merchantApi;